export default "__VITE_ASSET__CrhC3V9L__"